// TermsAndConditions.js
import React from 'react';
import {Container} from "react-bootstrap";
// import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <>
      <Container>
        <h2>TERMS AND CONDITIONS</h2>

        <section className="purpose">
          <h3>Purpose:</h3>
          <p>
            1.1 By accessing and using the SaaS-based automated stock trading tool (the "Service"), you agree to comply
            with
            and be bound by these terms and conditions (the "Terms"). If you do not agree to these Terms, please refrain
            from using the Service.
          </p>
          <p>
            1.2 The Terms and Conditions (“Terms”) also govern the associated upgrades, patches, support, and updates
            and
            related services currently provided or which will be provided by M/s. Fort Investech Systems Ltd., or any
            one
            of its subsidiaries, affiliated companies, parents, officers, directors, suppliers, licensors, agents,
            shareholders, and employees (collectively referred to as “Fort Investech”).
          </p>
          <p>
            1.3 The use of Software is subject to market risk and any investment made by placing reliance on the
            Software
            is at your sole discretion and risk. Fort Investech shall in no way be responsible for any losses incurred
            by
            you due to investments made by placing reliance on or using the Software.
          </p>
        </section>

        <section className="accepting-the-terms">
          <h3>Accepting the terms:</h3>
          <p>
            By clicking on ‘I Accept’, you agree that you have read and understood the terms and conditions set forth
            including any supplements thereto and all specifications and other documents referred to in these Terms.
          </p>
          {/*<p>*/}
          {/*  <strong>Privacy Policy:</strong> We value your right to privacy and take steps to protect it. For more*/}
          {/*  information, please refer to our current Privacy Policy, located at www.fortinves.tech*/}
          {/*</p>*/}
        </section>

        <section className="use-of-service">
          <h3>Use of Service:</h3>
          <p>
            3.1 Eligibility: You must be of legal age in your jurisdiction and have the legal capacity to enter into
            this
            agreement
          </p>
          <p>3.2 Subscription: Access to the Service is granted through a subscription Plan. You agree to pay the
            applicable fees as per the selected plan.</p>
          <p>3.3 Accuracy of Information: You acknowledge that the service relies on market data and external sources,
            and
            we do not guarantee the accuracy, completeness or timeliness of such information.</p>
        </section>

        <section className="services">
          <h3>Services:</h3>
          <p>
            Fort Investech aims at providing hassle-free investment and trading for its customers. The services provided
            by
            Fort Investech are Automated Software for the execution of an option selected by you for trading and
            investing
            in stock markets on the platform of the third-party application where you have an account.
          </p>
        </section>

        <section className="fee-payment">
          <h3>5. Fees and Payment:</h3>
          <p>
            5.1 Pricing: The subscription payment is as per defined in the website and change without prior notice, at
            that
            time you have the option to continue or to stop using the service.
          </p>
          <p>
            5.2 Payments once made as per the subscription plan, are not refundable under any circumstances.

            Unless you and Fort Investech agree otherwise in a separately executed written agreement for a specific
            payment
            plan, the pricing is as per the subscription chosen online on website of www.fortinves.tech
          </p>
          <p>
            5.3 Authorization for payment:

            You agree to give the Software permission to charge you using that payment method for any services used
            during
            the Service Period. As indicated in a subscription, software may bill at the time of purchase and on usage-
            basis.
          </p>
          <p>
            5.4 Responsibility for payment:

            You agree that you are authorized to use the payment method chosen by you at the time of subscribing to the
            Software. You can access and modify your payment information on the website and may change your payment
            method
            at any time.
          </p>
          <p> 5.5 Billing schedule:

            <p>(a) Invoices shall be raised by Fort Investech for the Subscription Fee and the Usage Fee as per the
              timeline
              stipulated in Clause 5.1. A copy of the invoice shall be issued to your email address.
            </p>

            <p>
              (b) All payments via check, wire transfer, or Automated Clearing House (ACH) are due within 30 days of the
              invoice date unless otherwise agreed-to by Fort Investech.
            </p>

            <p>
              (c) If any payment is not made when due, the Software shall be immediately suspended and access to the
              Services
              shall be terminated.
            </p>
          </p>
        </section>

        <section className="warranties">
          <h3>6. Warranties:</h3>

          <p>6.1 Use of Fort Investech’s Software, and the personal information you provide is at your sole discretion
            and
            risk. Fort Investech’s Software and all materials, information, products and services included therein, are
            provided on an AS IS and AS AVAILABLE basis without warranties from Fort Investech.</p>

          <p>
            6.2 Fort Investech does not make and hereby disclaims any guarantees, conditions, warranties of any kind,
            express, implied or statutory or other terms including as to:
          </p>
          <p>
            (a) its conformity, accuracy, correctness,
            completeness, reliability or security
          </p>
          <p>
            (b) its suitability for a particular use;
          </p>
          <p>
            (c) implied
            warranties of
            title,
            non-infringement;
          </p>
          <p>
            (d) its market value; or
          </p>
          <p>
            (e) your satisfaction.
          </p>

          <p>
            6.3 Fort Investech warranties will not apply if there has been misuse, modification, damage caused due to
            your
            failure to comply with applicable laws and regulations or with instructions and documentation provided by
            Fort
            Investech, or if otherwise stated.
          </p>


          <p>
            6.4 Any information and/or documentation provided by you is true, accurate and complete and you will
            promptly
            notify us in writing of any occurrence that results, or threatens to result, in any representations by you
            already made becoming inaccurate, false, misleading or incomplete on you becoming aware of the same.
          </p>

          <p>
            6.5 You are obligated to make necessary disclosures, obtain consent, if required, before providing any
            individual’s information, including personal or other regulated information. If any information could be
            subject
            to governmental regulation or may require security measures beyond those specified by Fort Investech for an
            offering, you will not provide, or allow such information unless specifically permitted or unless Fort
            Investech
            has otherwise first agreed in writing to implement additional security and other measures.
          </p>

          <p>
            6.6 You are responsible for the timely payment of the subscription fees, and you are entitled to access the
            Services only to the extent of authorizations provided by you. In any case, you are responsible for usage of
            the
            Services by any user who has access to the Services with your account credentials.
          </p>

          <p>
            6.7 No advice or information, whether oral or written, obtained by you from Fort Investech’s Website, shall
            create any warranty. If you choose to rely on such information, you do so solely at your own risk.
          </p>

        </section>

        <section className="liability">
          <h3>8. Liability:</h3>

          <p>8.1 Fort Investech’s aggregate liability for damages resulting from any failure to provide Services shall
            be limited to the amount of Subscription Fee paid by you for the respective Subscription term during which
            the claim for damages arises.</p>

          <p>8.2 Fort Investech shall not be responsible for any damages arising in connection with inability to use the
            Services.</p>

          <p>8.3 Fort Investech will not be liable to you or any third party for any consequential, incidental, special,
            direct, or indirect damages arising out of availing of Services (including but not limited to lost profits,
            trading losses or damages that result from use or loss of use of the Fort Investech platform and third party
            content, inconvenience or delay).</p>

          <p>8.4 Fort Investech will not be liable to you or anyone else for any loss resulting from a cause over which
            such Fort Investech does not have direct control. This includes but is not limited to failure of electronic
            or mechanical equipment or communications lines (including telephone, cable and internet), unauthorized
            access, viruses.</p>
        </section>

        <section className="indemnity">
          <h3>9. Indemnity:</h3>

          <p>You hereby agree to defend, indemnify and keep indemnified Fort Investech and its affiliates, their
            partners, associated service providers and their subcontractors against any claim or alleged claims,
            liabilities, losses damages and all costs (including attorneys’ fees) arising from the violation of these
            terms, your inability to use the Services provided by the Software, violation of applicable laws, or
            violation of rights of another party.</p>
        </section>

        <section className="disclaimer">
          <h3>10. Disclaimer:</h3>

          <p>You expressly acknowledge and agree that:</p>
          <p>10.1 Fort Investech may, at its sole discretion, change or discontinue the Services at any time after the
            completion of a (30) thirty day notice period, subject to statutory legal provisions of the laws of Dubai
            International Financial Centre, Dubai, in accordance with Clause 12 of these terms and conditions.</p>
          <p>10.2 Fort Investech follows the strategy provided by you and does not work in accordance with any strategy
            without your consent.</p>
          <p>10.3 Fort Investech is not advising you to invest in any particular security or securities or to pursue any
            investment strategy. All investments have risks, and you are responsible for determining whether you can
            afford the risks of making any investment.</p>
          <p>10.4 Fort Investech may modify the Software at any time without providing any prior notice to you and the
            modifications made shall be considered to be accepted if you continue to use the Software post the
            modifications.</p>
          <p>10.5 By using the Software provided by Fort Investech, you direct us to provide and retrieve information
            from the third party institution which maintains your accounts. The said information shall be subject to the
            privacy settings that you have set in such third party accounts, personally identifiable information that
            you post to your third party accounts.</p>
          <p>10.6 Nothing in the terms and conditions shall be deemed as an agency and partnership or any other
            corporate or fiduciary relation between you and Fort Investech. Neither party shall be responsible for the
            act and omission of the other party.</p>
          <p>10.7 Investments made are subject to market risks, all related documents to this regard are to be
            considered by you carefully before providing any instruction to Fort Investech. The value of the stocks may
            go up or down depending upon the factors and forces affecting the market including the fluctuations in the
            interest rates. Past performance is not necessarily indicative of future performance of the share and Fort
            Investech cannot be held responsible/liable for the performance of the market.</p>
          <p>10.8 There is no guarantee or assurance for any dividend under any of the stocks and the same is subject to
            the availability and adequacy of distributable surplus. You must review the prospectus carefully and obtain
            expert professional advice with regard to specific legal, tax and financial implications of the investment
            before approaching Fort Investech.</p>
        </section>

        <section className="intellectual-property">
          <h3>11. Intellectual Property:</h3>

          <p>Excluding any information you may provide to Fort Investech, you acknowledge that:</p>
          <p>11.1 the Software Services and its contents are protected under the applicable copyright, trademark and
            other laws.</p>
          <p>11.2 the Software Services and its contents thereof, and all intellectual property rights therein, are
            owned by Fort Investech.</p>
          <p>11.3 Our name, logo, and the services associated with the Software belong to us or our suppliers or
            licensors, and no right or license is granted to use them by implication, estoppel, or otherwise.</p>
          <p>11.4 Neither these Terms nor your access to the Software transfers to you or any third party any rights,
            title, or interest in or to such intellectual property rights, except for the limited access rights
            expressly set forth herein.</p>
          <p>11.5 Fort Investech reserves all rights not granted in these Terms. There are no implied licenses granted
            under these Terms.</p>
          <p>11.6 You may download or print a copy of information provided on the Site or through the Services for your
            personal, internal and non-commercial use only.</p>
        </section>

        <section className="termination">
          <h3>12. Termination:</h3>

          <p>12.1 The terms and conditions shall be valid until the time you use the Services of Fort Investech. After
            the initial Subscription, the Subscription shall renew automatically unless terminated by you or by Fort
            Investech by giving thirty (30) days’ prior notice.</p>
          <p>12.2 Fort Investech may suspend, revoke your use of the Services if Fort Investech determines there is a
            material breach of your obligations, a security breach, or violation of law. If the cause of the suspension
            can reasonably be remedied, Fort Investech will provide notice of the actions you must take to reinstate the
            Services. If you fail to take such actions within a reasonable time, Fort Investech may terminate the
            Services.</p>
          <p>12.3 Any termination, suspension or revocation, shall not affect your obligations to Fort Investech under
            these Terms (including but not limited to, indemnification, and liability), which by their sense and context
            are intended to survive such termination, suspension or revocation.</p>
        </section>

        <section className="misc">
          <h3>13. Miscellaneous:</h3>

          <p>13.1 Applicable law and Jurisdiction:</p>
          <p>Any disputes or claims arising out if or in connection with it or its subject matter or formation are
            governed by and shall be in accordance with the Dubai International Financial Centre, Dubai. The Courts of
            Dubai International Financial Centre have exclusive jurisdiction to settle any dispute or claim that arises
            out of the terms and conditions and its subject matter.</p>
          <p>13.2 Communication:</p>
          <p>(i) You agree that these terms and conditions contained herein, and Fort Investech enforcement thereof, are
            not intended to confer and do not confer any rights or remedies on any person other than you and Fort
            Investech. These Terms and conditions together with the Fort Investech’s Privacy Policy constitute the
            entire agreement between Fort Investech and you with respect to the subject matter hereof.</p>
          <p>(ii) Any notice or other communication to be given hereunder will be in writing and given by:</p>
          <p>(a) Fort Investech via email shivani@fortinvestech.com or</p>
          <p>(b) You via email to sid@fortinvestech.com or to such other addresses as Fort Investech may specify in
            writing. The date of receipt shall be deemed the date on which such notice is transmitted.</p>
          <p>(iii) You may contact Fort Investech’s Help Desk Monday to Friday between 8am and 8pm by sending an email
            or via phone call to info@fortinvestech.com and phone number: +971504716872. Fort Investech shall use its
            commercially reasonable efforts to offer support to you during these times but does not guarantee the Help
            Desk support to be uninterrupted or that Fort Investech will correct all errors reported.</p>
        </section>

      </Container>
    </>
  );
};

export default TermsAndConditions;
